import { GET_ENTRY_STRATEGIES, GET_ENTRY_STRATEGIES_ERROR, GET_ENTRY_STRATEGIES_SUCCESS } from './actionTypes';

export const getEntryStrategies = (token) => {
  return {
    type: GET_ENTRY_STRATEGIES,
    payload: { token },
  };
};

export const getEntryStrategiesSuccess = (payload) => {
  return {
    type: GET_ENTRY_STRATEGIES_SUCCESS,
    payload: payload,
  };
};

export const getEntryStrategiesError = (payload) => {
  return {
    type: GET_ENTRY_STRATEGIES_ERROR,
    payload: payload,
  };
};
